"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIAbstractIllustration;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _uiImages = require("ui-images");

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _omit = _interopRequireDefault(require("../utils/underscore/omit"));

var _BrowserTest = require("../utils/BrowserTest");

var _UIImage = _interopRequireDefault(require("./UIImage"));

function UIAbstractIllustration(props) {
  var className = props.className,
      disabled = props.disabled,
      name = props.name,
      _getImageUrlFromName = props._getImageUrlFromName,
      rest = (0, _objectWithoutProperties2.default)(props, ["className", "disabled", "name", "_getImageUrlFromName"]);

  if (process.env.NODE_ENV !== 'production') {
    if (props.height == null && props.width == null) {
      _devLogger.default.warn({
        message: 'UIAbstractIllustration: Provide either width or height prop to ensure proper scaling.',
        key: 'UIAbstractIllustration-dimensions-none'
      });
    }

    if (props.height != null && props.width != null) {
      _devLogger.default.warn({
        message: 'UIAbstractIllustration: Setting both width and height may not behave as expected.',
        key: 'UIAbstractIllustration-dimensions-both'
      });
    }
  }

  return _react.default.createElement(_UIImage.default, Object.assign({}, rest, {
    responsive: false,
    className: (0, _classnames.default)(className, 'private-illustration', disabled && 'private-illustration--disabled'),
    objectFit: "contain",
    src: _getImageUrlFromName(name)
  }));
}

UIAbstractIllustration.propTypes = Object.assign({}, (0, _omit.default)(_UIImage.default.propTypes, 'src', 'responsive'), {
  disabled: _propTypes.default.bool,
  height: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  name: _propTypes.default.string,
  width: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  _getImageUrlFromName: _propTypes.default.func.isRequired
});
UIAbstractIllustration.defaultProps = Object.assign({}, (0, _omit.default)(_UIImage.default.defaultProps, 'responsive'), {
  _getImageUrlFromName: function _getImageUrlFromName(name) {
    return (0, _uiImages.getImageUrl)(name, undefined, (0, _BrowserTest.isIE11)());
  }
});
UIAbstractIllustration.displayName = 'UIAbstractIllustration';
module.exports = exports.default;